(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Distribution_list', Distribution_list);

    Distribution_list.$inject = ['$resource'];

    function Distribution_list ($resource) {
        var resourceUrl =  'api/distribution-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
